import { makeStyles } from '@mui/styles';
import React, { useContext } from 'react';

import { Background } from './Background';
import { SceneCanvasContext, ViewMode } from './SceneCanvasContext';
import { SVGCharacter } from './SVGCharacter';
import { SVG_CANVAS_WIDTH, SVG_CANVAS_HEIGHT } from './utils';

const useStyles = makeStyles({
  svgRoot: {
    boxShadow: '0px 10px 13px -7px #000000, 5px 5px 15px 5px rgba(0,0,0,0)',
    maxWidth: '100%',
    maxHeight: '100%',
  },
});

export const Scene: React.FC = () => {
  const { svgRoot } = useStyles();

  const {
    viewMode,
    characters,
    clearCharacterFocus,
    svg: { svgContainerRef },
  } = useContext(SceneCanvasContext);

  return (
    <svg
      ref={svgContainerRef}
      className={svgRoot}
      viewBox={`0 0 ${SVG_CANVAS_WIDTH} ${SVG_CANVAS_HEIGHT}`}
      preserveAspectRatio="xMidYMid meet"
      onMouseLeave={() => {
        if (viewMode === ViewMode.EDIT) {
          clearCharacterFocus();
        }
      }}
      onMouseUp={() => {
        if (viewMode === ViewMode.EDIT) {
          clearCharacterFocus();
        }
      }}
    >
      <Background />

      {characters.map((char) => {
        return <SVGCharacter key={char.id} characterId={char.id} />;
      })}
    </svg>
  );
};
